import { createSign } from "node:crypto";
import {
  Accessor,
  batch,
  Component,
  createEffect,
  createMemo,
  createSignal,
  For
} from "solid-js";
import { preview } from "vite";
import { paymentType, paymentTypeNames } from "~/mydata";
import { itemGrossTotal } from "~/onesign/invoice-totals";
import { amount } from "~/schemas/amount";
import { invoiceSchema, payment } from "~/schemas/invoices";
import { useValidationState } from "~/zod-forms";
import { maybeNativeEnum } from "./helpers";
import SelectFormControl from "./SelectFormControl";

export const paymentTypes = [
  paymentType.Cash,
  paymentType.POS,
  paymentType.WebBanking,
  paymentType.BankDepositDomestic,
  paymentType.BankDepositForeign,
  paymentType.Credit,
  paymentType.Check,
];
const defaultPaymentType = paymentTypes[0];
const InvoicePayment: Component<{ index: number, setPaymentMeans(paymentMeans: number): void, remainingAmount: Accessor<string>, payingAmount: Accessor<string> }> = (props) => {
  const form = useValidationState<typeof invoiceSchema>();
  const [payment, setPayment] = form.bind(
    `payments[${props.index}]` as "payments[0]"
  );
  const [items] = form.bind("items");
  // const grossTotal = createMemo(() => itemGrossTotal(...(items() ?? [])));
  createEffect(() => {
    // const amount = grossTotal().toFixed(2);
    const amount = props.payingAmount();
    setPayment((prev) => ({
      ...(prev ?? {
        type: defaultPaymentType,
      }),
      amount,
    }));
  });
  return (
    <SelectFormControl
      label="Τρόπος πληρωμής"
      value={String(payment()?.type ?? defaultPaymentType)}
      onChange={(e) => {
        const value = maybeNativeEnum(paymentType)(e.currentTarget.value);
        setPayment((prev) => ({
          ...(prev ?? {
            amount: "0",
          }),
          type: value ?? defaultPaymentType,
        }));

        if (value) {
          props.setPaymentMeans(value);
        }

      }}
      classList={{
        ["p-2"]:true,
        ["mt-2"]:true,
      }}
    >
      <For each={paymentTypes}>
        {(typ) => <option value={typ}>{paymentTypeNames[typ]}</option>}
      </For>
    </SelectFormControl>
  );
};
export default InvoicePayment;
